import { createFileRoute } from "@tanstack/react-router";
import type {} from "@tanstack/react-start";
import { GonePage, goneHandler } from "@/lib/seo/gone";

// Retired: Roman-Urdu helpline mirrors.
export const Route = createFileRoute("/roman/helpline/$")({
  server: { handlers: { GET: goneHandler } },
  component: GonePage,
});
